<template>
    <div class="session-expired text-secondary">
        <div class="session-expired-content">
            <h1>Session expired</h1>
            <p>Your session has expired. Check your link or create a new session.</p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.session-expired {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    .session-expired-content {
        text-align: center;
        background: white;
        padding: 40px;

        display: flex;
        flex-direction: column;
        align-items: center;

        h1 {
            font-size: 2em;
            color: #dc3545;
            margin-bottom: 20px;
            text-transform: uppercase;
        }

        p {
            font-size: 1em;
            color: #6c757d;
        }
    }
}
</style>
